<template>
  <div class="container-layout">
    <!--头部-->
    <layout-header class="container-header" />
    <!--下部的内容-->
    <div class="container-body">
      <!--左侧的侧边栏-->
      <layout-sidebar class="container-body_sidebar" />
      <!--右侧的路由-->
      <div class="container-body_content">
        <!--上方的面包屑-->
        <layout-breadcrumb class="container-body_content__breadcrumb">
          <!--右侧的返回按钮-->
          <template #right>
            <div class="container-body_content__breadcrumb___button" @click="handleClick">
              <div />
            </div>
          </template>
        </layout-breadcrumb>
        <!--下方的路由出口-->
        <router-view class="container-body_content__routerview" />
      </div>
    </div>
  </div>
</template>

<script>
import LayoutSidebar from './sidebar/index'; //侧边栏
import LayoutHeader from './header/index.vue'; //头部菜单
import LayoutBreadcrumb from './breadcrumb/index.vue'; //面包屑
export default {
  name: 'Layout',
  components: {
    LayoutHeader, //layout的头部菜单
    LayoutSidebar, //侧边栏
    LayoutBreadcrumb, //面包屑
  },
  methods: {
    // 跳转到上一路由
    handleClick() {
      // 路由跳转
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
// 容器的背景颜色
$background-color-content: rgb(245, 246, 247);
// 侧边栏的背景颜色
$background-color-sidebar: rgb(248, 249, 251);
// 整体的容器
.container-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // 头部菜单
  .container-header {
    position: relative;
    min-height: 64px;
    max-height: 64px;
  }
  // 下部的展示内容
  .container-body {
    overflow-y: hidden;
    flex: 1;
    display: flex;
    // 侧边栏
    .container-body_sidebar {
      width: 200px;
      background: $background-color-sidebar;
      position: relative;
    }
    // 路由展示信息
    .container-body_content {
      flex: 1;
      background: $background-color-content;
      display: flex;
      flex-direction: column;
      // 面包屑
      .container-body_content__breadcrumb {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: rgb(255, 255, 255);
        padding: 0px 16px;
        box-shadow: rgba(9, 61, 133, 0.06) 0px 2px 3px 0px;
        font-size: 14px;
        -webkit-box-pack: justify;
        display: flex;
        justify-content: space-between;
        align-items: unset;
        // 面包屑的右侧按钮
        .container-body_content__breadcrumb___button {
          width: 28px;
          height: 28px;
          padding: 5px;
          border: 1px solid rgba(9, 61, 133, 0.06);
          border-radius: 8px;
          margin-top: 5px;
          cursor: pointer;
          // 内容的图标
          div {
            width: 18px;
            height: 18px;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUdwTCZy0yRy0yZ11SRy0yRx0yp52yVy0yRy0yl01iVy0yV01SRy0zCQ4CVz1CRy0yRy0yVz1CRx0oNqLMUAAAASdFJOUwB91C313hPA6iDMOVQFR524WZMupA8AAABlSURBVCjPrZI7EsAgCEQVMaLxF+5/2FSJFGsnHW9ngN3BueMVYoc8i2TIowTErx0nviEvmLukkv6ao7ZPmFYorCmvUcZDq8IBL7kiNXxWV78xSMVaN5EMtqHU1XjdRH1QeOjoE7wxIQNopCtgSQAAAABJRU5ErkJggg==);
            vertical-align: middle;
            background-size: 100% 100%;
          }
        }
      }
      // 路由出口
      .container-body_content__routerview {
        flex: 1;
        padding: 15px;
        overflow-y: auto;
      }
    }
  }
}
</style>
